import React, { useRef } from 'react';

import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';
import { media } from '@atlaskit/primitives';

const endOfPageRecContainerStyles = xcss({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	paddingBottom: 'space.250',
	margin: 'auto',
	width: '87.5%',
	[media.above.lg]: { maxWidth: '1000px' },
});

const relatedPagesSpecSectionSpacingStyles = xcss({
	paddingTop: 'space.300',
});

const maxWidthStyles = xcss({
	width: 'unset',
	maxWidth: 'unset',
});

export const EndOfPageRecContainer = ({
	children,
	ssrPlaceholderIdProp,
	isDefaultWidth,
	isCompactRelatedContentSpecSpacing,
}: {
	children: React.ReactNode;
	ssrPlaceholderIdProp: any;
	isDefaultWidth: boolean;
	isCompactRelatedContentSpecSpacing?: boolean;
}): React.JSX.Element => {
	const componentRef = useRef<HTMLDivElement>(null);

	return (
		<Box
			data-testid="test-rec"
			data-vc="end-of-page-recommendation-component"
			ref={componentRef}
			testId="test-rec"
			xcss={[
				endOfPageRecContainerStyles,
				isCompactRelatedContentSpecSpacing && relatedPagesSpecSectionSpacingStyles,
				!isDefaultWidth && maxWidthStyles,
			]}
			{...ssrPlaceholderIdProp}
		>
			{children}
		</Box>
	);
};
